import {
  Box,
  DialogContent,
  Link,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import {useTranslate} from 'hooks';
import React from 'react';
import {FontIcon, VisibilityLoading} from '../../../components';

type OpenBankingDisbursementDialogContentProps = {
  accountId?: string;
  isLoading?: boolean;
  error?: boolean;
};

export const OpenBankingDisbursementDialogContent: React.FC<
  OpenBankingDisbursementDialogContentProps
> = ({isLoading, error}) => {
  const translate = useTranslate();

  return (
    <DialogContent>
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 200,
          }}>
          <VisibilityLoading isLoading />
        </Box>
      ) : (
        <Stack spacing={2}>
          <Typography>
            {translate('savings.openbanking.disbursement.dialog.description')}
          </Typography>

          <Typography fontWeight="bold">
            {translate('savings.openbanking.disbursement.dialog.how-title')}
          </Typography>

          <List dense disablePadding>
            <ListItem>
              <ListItemText
                primary={translate(
                  'savings.openbanking.disbursement.dialog.step1',
                )}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={translate(
                  'savings.openbanking.disbursement.dialog.step2',
                )}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={translate(
                  'savings.openbanking.disbursement.dialog.step3',
                )}
              />
            </ListItem>
          </List>

          <Typography>
            {translate('savings.openbanking.disbursement.dialog.aiia-info')}
          </Typography>

          <Link
            href={translate(
              'savings.openbanking.disbursement.dialog.aiia-link.url',
            )}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            {translate(
              'savings.openbanking.disbursement.dialog.aiia-link.text',
            )}
            <FontIcon icon="arrow-up-right-from-square" size="sm" />
          </Link>

          {error && (
            <Typography color="error">{translate('common.error')}</Typography>
          )}
        </Stack>
      )}
    </DialogContent>
  );
};
